/* @flow */
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import AppStoreBadges from '../../components/AppStoreBadges';
import { ReviewBlock, ThreeFeaturesBlock } from '../components';
import {
  BodyText,
  Container,
  Illustration,
  SectionTitle,
  Spacer,
  SteppedFeatureBlock,
} from '../../components/core';
import Colors from '../../constants/Colors';
import { PageBody } from '../../components/chrome';
import PhoneRow from '../../components/PhoneRow';
import { ResponsiveEstimateForm } from '../../components/EstimateForm';
import Reviews, { getReviewTagged } from '../../../data/Reviews';
import Road from '../../components/Road';
import type { ServicesPageChromeMetadata } from './ServicesPageChrome';
import Stores from '../../../data/Stores';
import StoreGrid from '../../components/StoreGrid';
import TinyStoreLogoRow from '../../components/TinyStoreLogoRow';
import tripRequests from '../../../redux/trip-requests';
import type { UseCase } from '../../../data/TripRequests';

class StoreDeliveryPage extends Component<{
  setNewTripRequestUseCase: (useCase: UseCase) => void,
}> {
  static metadata = {
    title: 'Store Delivery',
    description:
      'Same day furniture delivery in under an hour from your favorite stores like IKEA, World Market, Costco, West Elm, Crate & Barrel, Home Depot, Lowe’s & More! Get a free estimate it and try it today!',
  };

  static servicesMetadata: ServicesPageChromeMetadata = {
    illustration: 'female-customer-luggers-loading',
    id: 'store-delivery',
  };

  componentDidMount() {
    const { setNewTripRequestUseCase } = this.props;
    setNewTripRequestUseCase('store_delivery');
  }

  render() {
    return (
      <div>
        <TinyStoreLogoRow />
        <PageBody>
          <Container padded={true}>
            <SectionTitle title="Store delivery in under 1-hour" />
            <BodyText
              size="16"
              align="center"
              style={{ maxWidth: 630, marginLeft: 'auto', marginRight: 'auto' }}>
              Shop that new sofa from your local furniture store and let us pick it up and deliver
              into your home, right where you want it. Same day. Effortlessly.
            </BodyText>
            <Spacer size={80} />
            <ThreeFeaturesBlock
              features={[
                {
                  title: 'Pick up from any store',
                  description:
                    'Shop at all your favorite places. We pick up from any store within our service area.',
                  icon: 'map-alt2',
                },
                {
                  title: 'Same day delivery',
                  description:
                    'Your purchases delivered in under 1-hour or any time that works best for you.',
                  icon: 'pick-a-time',
                },
                {
                  title: 'Your purchase protected',
                  description:
                    'Your delivery with Lugg will be backed by our multi-million dollar insurance policy.',
                  icon: 'shield',
                },
              ]}
            />
          </Container>
          <Spacer size={120} />
          <Container size="large" padded={true}>
            <ResponsiveEstimateForm />
          </Container>
          <Spacer size={120} />
          <Container padded={true} align="center">
            <SectionTitle title="Anything delivered" subtitle="In 3 easy steps" />
            <Spacer size={100} />
            <SteppedFeatureBlock
              step="1"
              layout="horizontal"
              horizontalFigurePosition="left"
              figure={
                <PhoneRow
                  sources={[
                    {
                      src: require('../../../assets/images/screenshots/map.png'),
                      src2x: require('../../../assets/images/screenshots/map_2x.png'),
                    },
                    {
                      src: require('../../../assets/images/screenshots/vehicle-time.png'),
                      src2x: require('../../../assets/images/screenshots/vehicle-time_2x.png'),
                    },
                    {
                      src: require('../../../assets/images/screenshots/photo-description.png'),
                      src2x: require('../../../assets/images/screenshots/photo-description_2x.png'),
                    },
                  ]}
                />
              }
              title={<SectionTitle title="Request a lugg" />}
              body={
                <div>
                  <BodyText size="16">
                    Open the Lugg app, set your destination, add a photo of your receipt, and set a
                    time you like us to pickup your items.
                  </BodyText>
                  <AppStoreBadges />
                </div>
              }
            />
            <Road enrouteTo="pickup" />
            <SteppedFeatureBlock
              layout="horizontal"
              step="2"
              horizontalFigurePosition="right"
              figure={<Illustration name="luggers-moving-couch" />}
              title={<SectionTitle title="We pickup your items" />}
              body={
                <BodyText size="16">
                  Head on home, no need to stick around at the store. <br /> {"We'll"} arrive and
                  load your items.
                </BodyText>
              }
            />
            <Road enrouteTo="dropoff" />
            <SteppedFeatureBlock
              layout="horizontal"
              step="3"
              horizontalFigurePosition="left"
              figure={<Illustration name="male-customer-rate-and-tip" />}
              title={<SectionTitle title="We deliver into your home" />}
              body={
                <BodyText size="16">
                  We place your items right where you want them. Tell us about your experience and
                  tip your Luggers for a job well done.
                </BodyText>
              }
            />
            <Container size="large" padded={true}>
              <Spacer size={200} color={Colors.Divider} />
            </Container>
            <SectionTitle title="Delivery from these stores & more" />
            <Spacer size={56} />
            <StoreGrid stores={Stores} />
          </Container>
          <Container size="large" padded={true}>
            <Spacer size={200} color={Colors.Divider} />
          </Container>
          <Container padded={true}>
            <ReviewBlock review={getReviewTagged(Reviews, 'store-purchases-page')} />
          </Container>
        </PageBody>
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    dispatch => ({
      setNewTripRequestUseCase: useCase =>
        dispatch(tripRequests.actions.setNewTripRequestUseCase(useCase)),
    })
  )
)(StoreDeliveryPage);



// WEBPACK FOOTER //
// ./src/ui/pages/ServicesPage/StoreDeliveryPage.js